import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import * as Yup from 'yup';

import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { pagesKey } from '@dashboard/lib/queryKeys';

import DialogOld from './DialogOld';
import Form from './Formik/Form';
import Description from './Description';

const AddStoreNameDialog = ({ isOpen }) => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();
  const queryClient = useQueryClient();

  return (
    <DialogOld isOpen={isOpen} title="Add your store name">
      <Description>We're missing a store name for your account. Please add one below.</Description>

      <div className="h-full flex-1 flex flex-col mt-2">
        <Form
          initialValues={{
            displayName: seller.displayName,
          }}
          onSubmit={async values => {
            const { data, error } = await updateSeller(values);

            return {
              data,
              error,
              onSuccess: () => queryClient.invalidateQueries({ queryKey: pagesKey }),
            };
          }}
          validationSchema={Yup.object().shape({
            displayName: Yup.string()
              .required('Store name is required')
              .min(3, 'Store name must be at least 3 characters')
              .max(50, 'Store name must be at most 50 characters'),
          })}
          fields={[
            {
              name: 'displayName',
              label: 'Store name',
              type: 'text',
              placeholder: 'e.g. My Store',
              defaultValue: seller.displayName,
              required: true,
            },
          ]}
          submitButton={{
            label: 'Save',
            size: 'full',
          }}
          showState={false}
        />
      </div>
    </DialogOld>
  );
};

export default AddStoreNameDialog;
